import { INavNode } from "@logex/framework/lg-application";
import { NavigationIds } from "@shared/navigation-ids";
import { ApplicationPermissions } from "./types/app-permissions";
import { ConfigService } from "@shared/services";

const navTree: INavNode[] = [
    {
        path: "",
        noBreadcrumb: true,
        narrowed: false,
        id: "root",

        children: [
            {
                path: "editor",
                id: "editor",
                permissions: [ApplicationPermissions.READ],
                narrowed: false,
                noBreadcrumb: true,
                hidden: true
            },
            {
                path: "editor/start",
                lid: "APP._Menu.Start",
                id: NavigationIds.EditorStart,
                permissions: [ApplicationPermissions.READ],
                narrowed: false,
                noBreadcrumb: false
            },
            {
                path: "editor/dataSets",
                lid: "APP._Menu.DataSets",
                id: NavigationIds.DataSets,
                permissions: [ApplicationPermissions.READ],
                narrowed: false
            },
            {
                path: "editor/entityGroups",
                lid: "APP._Menu.EntityGroups",
                id: NavigationIds.EntityGroups,
                permissions: [ApplicationPermissions.READ],
                narrowed: false
            },
            {
                path: "editor/entities",
                lid: "APP._Menu.Entities",
                id: NavigationIds.Entities,
                permissions: [ApplicationPermissions.READ],
                narrowed: false
            }
        ]
    }
];

const settingsNode = (configService: ConfigService): INavNode => {
    const dataPlatformUrl = configService.configuration?.dataPlatformUrl?.replace(/\/+$/, "") ?? "";

    return {
        path: "",
        lid: "APP._Navigation.Settings",
        id: "settings",
        noBreadcrumb: true,
        hidden: true,
        children: [
            {
                path: `${dataPlatformUrl}/notifications`,
                id: "notifications",
                lid: "APP._Navigation.Notifications"
            },
            {
                path: `${dataPlatformUrl}/emulation`,
                id: "emulation",
                lid: "APP._Navigation.Emulation"
            }
        ]
    };
};

export const getNavigation: (
    permissions: ApplicationPermissions,
    configService: ConfigService
) => INavNode[] = (_permissions, configService): INavNode[] => {
    return [...navTree, settingsNode(configService)];
};
